<template>
    
    <v-layout row wrap>
            
        <v-tabs dark centered>

            <v-tabs-bar class="grey darken-3">
               <v-tabs-slider color="orange"></v-tabs-slider>
                    <v-tabs-item href="#tab1" >
                        <v-btn flat class="grey--text">
                            Anschriftsdaten
                        </v-btn>
                    </v-tabs-item>
                    <v-tabs-item href="#tab2">
                        <v-btn flat class="grey--text">
                            Geokoordinaten
                        </v-btn>

                    </v-tabs-item>                      
            </v-tabs-bar>    

            <v-tabs-items>
                <v-tabs-content id="tab1">
                    <div>
                        <keep-alive>
                            <form-one v-on:submitted="submitForm"></form-one>
                        </keep-alive>
                    </div>
                </v-tabs-content>
                <v-tabs-content id="tab2">
                    <div>
                        <keep-alive>
                            <form-two v-on:submitted="submitForm"></form-two>
                        </keep-alive>
                    </div>
                </v-tabs-content> 
            </v-tabs-items>
        </v-tabs>    
              
    </v-layout>
    
</template>

<script>

import formOne from './editAdressen_1.vue';
import formTwo from './editAdressen_2.vue';


export default {
    components: {
        'form-one': formOne,
        'form-two' : formTwo
    },
    data() {
        return {

            id: this.$route.params.id    
        }
    }, 
    
     computed: {
        
         loading: function() {
            return this.$store.getters.loading
        }
    },   
    methods: {
        submitForm: function(ad) {
            this.$store.commit('setMessagebar', false)
            this.$store.dispatch('putAdresse', ad).then((response)=>{                
                
                this.$store.dispatch('setAdresse', this.id)
                
                this.$router.push('/firmen')
            })
            this.$store.commit('setMessagebar', true)
        },
    },
    
    created(){
        
        this.$store.dispatch('setAdresse', this.id)

    },
    
}
</script>

<style>
   
    
</style>



// WEBPACK FOOTER //
// editAdressen.vue?266d4dfe